import { lazy } from 'react'

const NewHomePage = lazy(() => import('src/Components/NewHomePage'))
const ServiceStatusPage = lazy(() => import('src/Components/ServiceStatusPage'))
const NoMatchPage = lazy(() => import('src/Components/NoMatch'))
const NewMerchantPage = lazy(() => import('src/Components/NewMerchantPage'))
const ContactUsPage = lazy(() => import('src/Components/ContactUsPage'))
const AboutUsPage = lazy(() => import('src/Components/AboutUsPage'))
const ShopeePayPage = lazy(() => import('src/Components/ShopeePayPage'))
const SPayLaterPage = lazy(() => import('src/Components/SPayLater'))
const SLoanPage = lazy(() => import('src/Components/SLoanPage'))
const InsurancePage = lazy(() => import('src/Components/InsurancePage'))
const PrivacyPage = lazy(() => import('src/Components/PrivacyPage'))
const TermsPage = lazy(() => import('src/Components/TermsPage'))
const LeadershipPage = lazy(() => import('src/Components/LeadershipPage'))
const MoneyPlusPage = lazy(() => import('src/Components/MoneyPlusPage'))
const NoticeDetailPage = lazy(() => import('src/Components/NoticeDetailPage'))
const InvestPage = lazy(() => import('src/Components/InvestPage'))

export const I18N_NAVIGATION_ROUTES = (t, language) => {
  return Object.freeze({
    home: {
      path: `/${language}`,
      exact: true,
      element: <NewHomePage />
    },
    Insurance: {
      path: `/${language}/${t('insurance')}`,
      element: <InsurancePage />
    },
    InsuranceType: {
      path: `/${language}/${t('insurance')}/:type`,
      element: <InsurancePage />
    },

    Merchant: {
      path: `/${language}/${t('merchant')}/:type`,
      element: <NewMerchantPage />
    },

    DefaultMerchant: {
      path: `/${language}/${t('merchant')}`,
      element: <NewMerchantPage />
    },
    noMatch: {
      path: '*',
      element: <NoMatchPage />
    },
    ContactUs: {
      path: `/${language}/${t('contactUs')}`,
      element: <ContactUsPage />
    },
    AboutUs: {
      path: `/${language}/${t('aboutUs')}`,
      element: <AboutUsPage />
    },
    ShopeePay: {
      path: `/${language}/${t('shopeepay')}`,
      element: <ShopeePayPage />
    },
    ShopeePayLater: {
      path: `/${language}/${t('spaylater')}`,
      element: <SPayLaterPage />
    },
    SLoan: {
      path: `/${language}/${t('sloan')}`,
      element: <SLoanPage />
    },
    Privacy: {
      path: '/privacy',
      element: <PrivacyPage />
    },
    Terms: {
      path: '/terms',
      element: <TermsPage />
    },
    Leadership: {
      path: `/${language}/${t('leadership')}`,
      element: <LeadershipPage />
    },
    MoneyPlus: {
      path: `/${language}/${t('moneyPlus')}`,
      element: <MoneyPlusPage />
    },
    ServiceStatus: {
      path: `/${language}/${t('serviceStatus')}`,
      element: <ServiceStatusPage />
    },
    NoticeDetail: {
      path: `/${language}/${t('serviceStatus')}/:id`,
      element: <NoticeDetailPage />
    },
    Invest: {
      path: `/${language}/${t('invest')}`,
      element: <InvestPage />
    }
  })
}
